<div class="page-wrapper" id="pageWrapper" [ngClass]="layoutClass">
    <app-superadmin-header></app-superadmin-header>
    <div class="page-body-wrapper" [class.scorlled]="hideScrollNavService.headerFixed == true">
        <div class="sidebar-wrapper" [class.close_icon]="navService.collapseSidebar"
            [attr.data-layout]="layout.config.settings.icon">
            <app-superadmin-sidebar></app-superadmin-sidebar>
        </div>
        <div class="page-body">
            <router-outlet></router-outlet>
        </div>
        <footer class="footer" [class.footer-dark]="footerDark" [class.footer-light]="footerLight"
            [class.footer-fix]="footerFix">
            <app-superadmin-footer></app-superadmin-footer>
        </footer>
    </div>
</div>